import React from 'react';
import { Badge } from '@/components/ui/badge';
import { Clock } from 'lucide-react';

interface TimezoneBadgeProps {
  timezone?: string;
  offset?: string;
  className?: string;
  size?: 'sm' | 'md' | 'lg';
}

const TimezoneBadge: React.FC<TimezoneBadgeProps> = ({ 
  timezone, 
  offset, 
  className = "",
  size = 'sm'
}) => {
  if (!timezone) return null;

  const displayText = timezone === 'UTC' 
    ? 'UTC' 
    : `${timezone}${offset ? ` (${offset})` : ''}`;

  const sizeClasses = {
    sm: 'text-xs px-3 py-1.5 gap-1.5',
    md: 'text-sm px-3 py-1.5 gap-2',
    lg: 'text-base px-4 py-2 gap-2'
  };

  return (
    <Badge 
      variant="outline" 
      className={`inline-flex items-center font-medium border-border/40 bg-background/50 text-muted-foreground hover:bg-accent/50 hover:text-accent-foreground transition-colors ${sizeClasses[size]} ${className}`}
    >
      <Clock className="h-3.5 w-3.5 text-muted-foreground/70" />
      <span className="font-mono tracking-tight">{displayText}</span>
    </Badge>
  );
};

export default TimezoneBadge;